import { useEffect } from "react";
import { WHATS_APP_LINK } from "./utils/phoneNumbers";
import HeroSection from "./components/HeroSection";
import ComoFunciona from "./components/ComoFunciona";
import WhatsAppButton from "./components/WhatsAppButton";
import Premios from "./components/Premios";
import Ganhadores from "./components/Ganhadores";
import Duvidas from "./components/Duvidas";
import Footer from "./components/Footer";
import "./App.css";

function App() {
  useEffect(() => {
    const loader = document.getElementById("preloader");
    loader.style.display = "none";
  }, []);

  return (
    <div className="App">
      <WhatsAppButton whatsAppNumber={WHATS_APP_LINK} />
      <HeroSection whatsAppNumber={WHATS_APP_LINK} />
      <ComoFunciona />
      <Premios />
      <Ganhadores />
      <Duvidas />
      <Footer whatsAppNumber={WHATS_APP_LINK} />
    </div>
  );
}

export default App;
